/*
 * validate.js
 *
 * Take a single value and validate it; return an object with a `valid` prop to indicate validity,
 * as well as am optional `message` prop to explain an invalid value.
 */

class Validate {
    /*
     * Slug validation (lowercase letters, numbers, & hyphens)
     */
    static slug(value) {
        if (value.endsWith("-") === true) {
            return {
                valid: false,
                message: "Slug can not end with a hyphen."
            }
        } else if ((new RegExp(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).test(value) !== true) {
            return {
                valid: false,
                message: "Slug can only contain lowercase letters, numbers, and hyphens."
            }
        } else {
            return {
                valid: true
            }
        }
    }

    /*
     * Email validation
     */
    static email(value) {
        if (value !== '' && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) !== true) {
            return {
                valid: false,
                message: "This doesn't look like a valid email address."
            }
        } else {
            return {
                valid: true
            }
        }
    }

    /*
     * Phone validation
     */
    static phone(value) {

        let regex =  /^\(?([0-9]{3})\)?[-. ]? ([0-9]{3}) [-. ]? ([0-9]{4})$/;

        if (value !== '' && !value.match(regex)) {
            return {
                valid: false,
                message: "This doesn't look like a valid phone number."
            }
        } else {
            return {
                valid: true
            }
        }
    }

    /*
     * ZIP Code validation
     */
    static zip(value) {

        if (value !== '' &&  /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value) !== true) {
            return {
                valid: false,
                message: "This doesn't look like a valid ZIP code."
            }
        } else {
            return {
                valid: true
            }
        }
    }

    /*
     * Marketron Number validation
     */
    static marketron(value) {

        if (typeof value === "string") {
            value = [value];
        }

        let invalidNumbers = [
            "TBA",
            "TBD",
            "00000",
            "000000",
            "0000000",
            "00000000",
            "000000000",
            "11111",
            "111111",
            "1111111",
            "11111111",
            "111111111",
            "22222",
            "222222",
            "2222222",
            "22222222",
            "222222222",
            "33333",
            "333333",
            "3333333",
            "33323333",
            "333322333",
            "44444",
            "444444",
            "4444444",
            "44444444",
            "444444444",
            "55555",
            "555555",
            "5555555",
            "55555555",
            "555555555",
            "66666",
            "666666",
            "6666666",
            "66666666",
            "666666666",
            "77777",
            "777777",
            "7777777",
            "77777777",
            "777777777",
            "88888",
            "888888",
            "8888888",
            "88888888",
            "888888888",
            "99999",
            "999999",
            "9999999",
            "99999999",
            "999999999",
            "12345",
            "123456",
            "1234567",
            "12345678",
            "123456789"
        ];

        let valid = true;
        let message = '';
        let whichInvalid = [];

        value.map(function(number) {
            if (number !== '' && (invalidNumbers.includes(number) || /(^\d{5}\d?\d?\d?\d?$)/.test(number) !== true)) {
                valid = false;
                whichInvalid.push(number);
            }
        });

        if (valid === false) {
            if (whichInvalid.length > 1) {

                message = "The following marketron numbers appear to be invalid: ";
                whichInvalid.map(function(invalidNumber) {
                   message += invalidNumber + ", ";
                });
                message = message.replace(/, ([^, ]*)$/, '$1');

            } else {
                message = "Sorry, but '" + whichInvalid[0] + "' does not appear to be a valid marketron number.";
            }
        }

       return {
           valid,
           message
       };
    }

    /*
     * URL validation
     */
    static url(value) {

        if (value !== '' &&  /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value) !== true) {
            return {
                valid: false,
                message: "This doesn't look like a valid URL."
            }
        } else {
            return {
                valid: true
            }
        }
    }

    /*
     * Money
     */
    static money(value) {
        if (value !== '' && /(?=.)^\$?(([1-9][0-9]{0,2}(,?[0-9]{3})*)|0)?(\.[0-9]{1,2})?$/.test(value) !== true) {
            return {
                valid: false,
                message: "This doesn't look like a valid dollar amount."
            }
        } else {
            return {
                valid:true
            }
        }
    }

    /*
     * Decimal or Time
     */
    static decimalOrTime(value) {
        if (
            value !== '' &&
            /^([0-9]*)?(\.[0-9]*)?$/.test(value) !== true &&
            /^([0-9]*)?\:([0-5][0-9])$/.test(value) !== true
        ) {
            return {
                valid: false,
                message: "Invalid time. Use a valid format (e.g. 1:15 or 1.25)."
            }
        } else {
            return {
                valid:true
            }
        }
    }


    /*
     * Password
     */
    static password(value) {
        if (value !== '' && value.length < 8) {
            return {
                valid: false,
                message: "Your password is too weak. Make sure it's at least 8 characters long and difficult to guess."
            }
        } else {
            return {
                valid:true
            }
        }
    }

}
export default Validate;


// WEBPACK FOOTER //
// ./src/utils/validate.js